import React, { Fragment, useRef, useState } from 'react';

import {
  ClickAwayListener,
  InputBase,
  Popper,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import AccountQuickSearchBox from 'modules/accountsSearch/components/AccountQuickSearchBox';

const HeaderSearch = () => {
  const searchRef = useRef(null);

  const dummySearches = [
    'Analytics',
    'Sales',
    'Buttons',
    'Cards',
    'Helpdesk',
    'Projects',
    'Statistics'
  ];

  return (
    <Box className="header-search-container" display="flex" alignItems="center">
      <AccountQuickSearchBox/>
    </Box>
  );
};

export default HeaderSearch;
